var map = {
	"./ProximaNova-Black.woff": "./fonts/ProximaNova-Black.woff",
	"./ProximaNova-Black.woff2": "./fonts/ProximaNova-Black.woff2",
	"./ProximaNova-BlackIt.woff": "./fonts/ProximaNova-BlackIt.woff",
	"./ProximaNova-BlackIt.woff2": "./fonts/ProximaNova-BlackIt.woff2",
	"./ProximaNova-Bold.woff": "./fonts/ProximaNova-Bold.woff",
	"./ProximaNova-Bold.woff2": "./fonts/ProximaNova-Bold.woff2",
	"./ProximaNova-BoldIt.woff": "./fonts/ProximaNova-BoldIt.woff",
	"./ProximaNova-BoldIt.woff2": "./fonts/ProximaNova-BoldIt.woff2",
	"./ProximaNova-Extrabld.woff": "./fonts/ProximaNova-Extrabld.woff",
	"./ProximaNova-Extrabld.woff2": "./fonts/ProximaNova-Extrabld.woff2",
	"./ProximaNova-ExtrabldIt.woff": "./fonts/ProximaNova-ExtrabldIt.woff",
	"./ProximaNova-ExtrabldIt.woff2": "./fonts/ProximaNova-ExtrabldIt.woff2",
	"./ProximaNova-Light.woff": "./fonts/ProximaNova-Light.woff",
	"./ProximaNova-Light.woff2": "./fonts/ProximaNova-Light.woff2",
	"./ProximaNova-LightIt.woff": "./fonts/ProximaNova-LightIt.woff",
	"./ProximaNova-LightIt.woff2": "./fonts/ProximaNova-LightIt.woff2",
	"./ProximaNova-Medium.woff": "./fonts/ProximaNova-Medium.woff",
	"./ProximaNova-Medium.woff2": "./fonts/ProximaNova-Medium.woff2",
	"./ProximaNova-MediumIt.woff": "./fonts/ProximaNova-MediumIt.woff",
	"./ProximaNova-MediumIt.woff2": "./fonts/ProximaNova-MediumIt.woff2",
	"./ProximaNova-Regular.woff": "./fonts/ProximaNova-Regular.woff",
	"./ProximaNova-Regular.woff2": "./fonts/ProximaNova-Regular.woff2",
	"./ProximaNova-RegularIt.woff": "./fonts/ProximaNova-RegularIt.woff",
	"./ProximaNova-RegularIt.woff2": "./fonts/ProximaNova-RegularIt.woff2",
	"./ProximaNova-Semibold.woff": "./fonts/ProximaNova-Semibold.woff",
	"./ProximaNova-Semibold.woff2": "./fonts/ProximaNova-Semibold.woff2",
	"./ProximaNova-SemiboldIt.woff": "./fonts/ProximaNova-SemiboldIt.woff",
	"./ProximaNova-SemiboldIt.woff2": "./fonts/ProximaNova-SemiboldIt.woff2",
	"./ProximaNova-ThinIt.woff": "./fonts/ProximaNova-ThinIt.woff",
	"./ProximaNova-ThinIt.woff2": "./fonts/ProximaNova-ThinIt.woff2",
	"./ProximaNovaA-Regular.woff": "./fonts/ProximaNovaA-Regular.woff",
	"./ProximaNovaA-Regular.woff2": "./fonts/ProximaNovaA-Regular.woff2",
	"./ProximaNovaT-Thin.woff": "./fonts/ProximaNovaT-Thin.woff",
	"./ProximaNovaT-Thin.woff2": "./fonts/ProximaNovaT-Thin.woff2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./fonts sync recursive ^\\.\\/.*$";